import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import OverlayTrigger from '@/components/Overlay/OverlayTrigger';
import { Popover } from 'react-bootstrap';
import React from 'react';
import styles from './Ranking.module.scss';

type Props = {
    modal?: boolean;
    name: string;
    popoverHeader: string;
    popoverText: string;
};

const Ranking = (props: Props) => {
    const { modal, name, popoverHeader, popoverText } = props;

    const nameStyles = Boolean(modal) ? classNames(styles.badgeName, styles.modal) : styles.badgeName;
    const ranking = (
        <div className={styles.badge}>
            <div className={styles.trophyContainer}>
                <img
                    alt="trophy"
                    className={styles.trophy}
                    src="https://p1.liveauctioneers.com/dist/images/trophy.svg"
                />
            </div>
            <span className={nameStyles}>
                <FormattedMessage id={name} />
            </span>
        </div>
    );

    return (
        <OverlayTrigger
            overlay={
                <Popover className={styles.popoverStyle} id={name}>
                    <div className={styles.popHeader}>
                        <img
                            alt="trophy"
                            className={styles.trophy}
                            src="https://p1.liveauctioneers.com/dist/images/trophy.svg"
                        />
                        <FormattedMessage id={popoverHeader} />
                    </div>
                    <span className={styles.popText}>
                        <FormattedMessage id={popoverText} />
                    </span>
                </Popover>
            }
            placement="bottom"
            trigger={['hover', 'focus']}
        >
            {ranking}
        </OverlayTrigger>
    );
};

Ranking.defaultProps = { name: 'ranking.accName', popoverHeader: 'header', popoverText: 'popoverText' };

export default React.memo<Props>(Ranking, isEqual);
